/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Current_PriceInputs */

const en_admin_external_booking_edit_current_price = /** @type {(inputs: Admin_External_Booking_Edit_Current_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current price`)
};

const de_admin_external_booking_edit_current_price = /** @type {(inputs: Admin_External_Booking_Edit_Current_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Preis`)
};

const es_admin_external_booking_edit_current_price = /** @type {(inputs: Admin_External_Booking_Edit_Current_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio actual`)
};

const fr_admin_external_booking_edit_current_price = /** @type {(inputs: Admin_External_Booking_Edit_Current_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix actuel`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Current_PriceInputs) => LocalizedString} */
const it_admin_external_booking_edit_current_price = en_admin_external_booking_edit_current_price;

/** @type {(inputs: Admin_External_Booking_Edit_Current_PriceInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_current_price = en_admin_external_booking_edit_current_price;

/** @type {(inputs: Admin_External_Booking_Edit_Current_PriceInputs) => LocalizedString} */
const pl_admin_external_booking_edit_current_price = en_admin_external_booking_edit_current_price;

/** @type {(inputs: Admin_External_Booking_Edit_Current_PriceInputs) => LocalizedString} */
const hu_admin_external_booking_edit_current_price = en_admin_external_booking_edit_current_price;

/** @type {(inputs: Admin_External_Booking_Edit_Current_PriceInputs) => LocalizedString} */
const ro_admin_external_booking_edit_current_price = en_admin_external_booking_edit_current_price;

/**
* | output |
* | --- |
* | "Current price" |
*
* @param {Admin_External_Booking_Edit_Current_PriceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_current_price = /** @type {((inputs?: Admin_External_Booking_Edit_Current_PriceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Current_PriceInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_current_price(inputs)
	if (locale === "de") return de_admin_external_booking_edit_current_price(inputs)
	if (locale === "es") return es_admin_external_booking_edit_current_price(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_current_price(inputs)
	if (locale === "it") return it_admin_external_booking_edit_current_price(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_current_price(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_current_price(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_current_price(inputs)
	return ro_admin_external_booking_edit_current_price(inputs)
});
export { admin_external_booking_edit_current_price as "admin.external_booking_edit.current_price" }